import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';
import FixedDataTable from 'fixed-data-table';
import $ from 'jquery';
import {
    FloatingActionButton,
    IconButton
} from 'material-ui';
import {
    blue400,
    blueGrey800
} from 'material-ui/styles/colors';
import AddIcon from 'material-ui/svg-icons/content/add';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import ChartIcon from 'material-ui/svg-icons/editor/insert-chart';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import KeyIcon from 'material-ui/svg-icons/communication/vpn-key';

const {Table, Column, Cell} = FixedDataTable;
const DateCell = ({rowIndex, data, col, props}) => (
    <Cell {...props}>
        {data.getObjectAt(rowIndex)[col].toLocaleString()}
    </Cell>
);

const ImageCell = ({rowIndex, data, col, props}) => (
    <ExampleImage
        src={data.getObjectAt(rowIndex)[col]}
    />
);

const LinkCell = ({rowIndex, data, col, props}) => (
    <Cell {...props}>
        <a href="#">{data.getObjectAt(rowIndex)[col]}</a>
    </Cell>
);

const TextCell = ({rowIndex, data, col, col2, props}) => {
    let label = (col2 != null) ? data[rowIndex][col][col2] : data[rowIndex][col];
    return (
        <Cell {...props}>
            {label}
        </Cell>
    );
};

const ManageCell = ({rowIndex, data, props}) => {
    const editLink = "/user/" + data[rowIndex]['id'] + '/edit';
    const editPasswordLink = "/user/" + data[rowIndex]['id'] + '/password';
    const manageLink = "/user/" + data[rowIndex]['id'] + '/manage';
    return (
        <Cell {...props}>
            <Link to={editLink}>
                <IconButton tooltip="Modifier" style={{padding: 0, marginRight: 5, width: 20, height: 20}}
                            iconStyle={{width: 20, height: 20}}>
                    <EditIcon color={blueGrey800}/>
                </IconButton>
            </Link>
            <Link to={editPasswordLink}>
                <IconButton tooltip="Modifier" style={{padding: 0, marginRight: 5, width: 20, height: 20}}
                            iconStyle={{width: 20, height: 20}}>
                    <KeyIcon color={blueGrey800}/>
                </IconButton>
            </Link>
            {/*<Link to={manageLink}>
                <IconButton tooltip="Gérer" style={{padding: 0, marginRight: 5, width: 20, height: 20}}
                            iconStyle={{width: 20, height: 20}}>
                    <SettingsIcon color={blueGrey800}/>
                </IconButton>
            </Link>*/}
        </Cell>
    );
};


class UserList extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        if(!this.props.users) return (<div></div>);
        const dataList = this.props.users;
        const height = $(window).height() - 154;
        const width = $(window).width() - 296;
        return (
            <div>
                <div style={{padding: '20px 0', position:'relative'}}>
                    <Link to="/user/new">
                        <FloatingActionButton mini backgroundColor={blue400} style={{right:0, position:'absolute', top:0}}>
                            <AddIcon />
                        </FloatingActionButton>
                    </Link>
                    {dataList.length} utilisateurs
                </div>
                <Table
                    rowHeight={36}
                    headerHeight={30}
                    rowsCount={dataList.length}
                    width={width}
                    height={height}
                    {...this.props}>
                    <Column
                        header={<Cell>Nom</Cell>}
                        cell={<TextCell data={dataList} col="lastname"/>}
                        fixed
                        width={200}
                    />
                    <Column
                        header={<Cell>Prénom</Cell>}
                        cell={<TextCell data={dataList} col="firstname"/>}
                        fixed
                        width={200}
                    />
                    <Column
                        header={<Cell>Email</Cell>}
                        cell={<TextCell data={dataList} col="email"/>}
                        fixed
                        width={200}
                    />
                    <Column
                        header={<Cell>Manage</Cell>}
                        cell={<ManageCell data={dataList}/>}
                        fixed
                        width={200}
                    />
                </Table>
            </div>
        );
    }
}

UserList.propTypes = {
    users: PropTypes.array
};

function mapStateToProps(state, ownProps) {
    return {
        state: state,
        users: state.users
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //actions: bindActionCreators(action, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserList);


/** WEBPACK FOOTER **
 ** ./src/components/UserList/index.js
 **/